import { sessionClient } from "@/app/auth/localStorage";
import React, { createContext, useContext, useEffect, useState } from "react";

export const SessionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [session, setSession] = useState<boolean>(sessionClient.readSession());

  useEffect(() => {
    setSession(session);
  }, []);

  return (
    <SessionContext.Provider
      value={{
        session,
        setSession,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

interface ISessionContext {
  session: boolean;
  setSession: (session: boolean) => void;
}

const defaultSessionContext = {
  session: false,
  setSession: (session: boolean) => {},
};

const SessionContext = createContext<ISessionContext>(defaultSessionContext);

export const useSession = () => useContext(SessionContext);
